import React, { Component } from 'react';
import {FormControl, Button,Row, Col,OverlayTrigger,Tooltip} from 'react-bootstrap';
import { translate } from "react-i18next";


class InvitedEdit extends Component {

    constructor(props) {
        super(props);

        this.onInvitedInputChange = this.onInvitedInputChange.bind(this);
        this.onActivate = this.onActivate.bind(this);
        this.state = {
            invited: this.props.selected,
            onInvitedRevertP:this.props.onInvitedRevertP
        };
    }

    onInvitedInputChange(event) {
        const { name: fieldName, value: fieldValue } = event.target;
        const { invited } = this.state;

        const newInvited = {
        ...invited,
        [fieldName]: fieldValue
        };

        this.setState({
        invited: newInvited
        });
   }

   onActivate(invited, invitationStatus){
       invited.invitationStatus = invitationStatus;
       this.props.onInvitedEdit(invited);
   }

   render() {
       const { t } = this.props;
       let blocked = this.state.invited.invitationStatus === 'BLOCKED';
       let newInvitationStatus = blocked? 'INVITED':'BLOCKED';
        return (
           <div className="bg-light p-2 mt-4">
                <Row>
                    <Col lg={4} md={8}>
                       <FormControl
                            placeholder={t("fullname")}
                            onChange={this.onInvitedInputChange}
                            name="name"
                            value={this.state.invited.name}
                    />
                    </Col>
                    <Col lg={5} md={8}>
                        <FormControl
                            placeholder={t("yourEmail")}
                            onChange={this.onInvitedInputChange}
                            name="email"
                            value={this.state.invited.email} 
                    />
                    </Col>
                </Row>
                <Row className=" mt-3 mb-2">
                <Col lg={1}  xs={1}>
                        &nbsp;
                    </Col>
                    <Col lg={2}  xs={2}  >
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-top`}>
                            {t("loeschen")}
                        </Tooltip>
                        }>
                        <Button variant="outline-primary" onClick={() => this.props.onInvitedDelete(this.state.invited.id)} ><span class="fa fa-trash-alt">&nbsp;{t("loeschen")}</span></Button>
                        </OverlayTrigger>
                    </Col>
                    <Col lg={2}  xs={2}>
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-top`}>
                            {t("verwerfen")}
                        </Tooltip>
                        }>
                            <Button variant="outline-primary" onClick={ this.props.onInvitedRevert} className="float-left  " ><span class="fa fa-undo">&nbsp;{t("verwerfen")}</span></Button>
                        </OverlayTrigger>
                        
                    </Col>
                    <Col lg={2}  xs={2}>
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                            blocked ?
                        <Tooltip id={`tooltip-top`}>
                            {t("aktivieren")}
                        </Tooltip>
                        :
                        <Tooltip id={`tooltip-top`}>
                            {t("Blockieren")}
                        </Tooltip>
                        }>
                            <Button variant="outline-primary" onClick={()  => this.onActivate(this.state.invited, newInvitationStatus)} className="float-left  " >
                                {blocked ? 
                                   <span class="fa fa-user">&nbsp;{t("aktivieren")}</span>
                                   :
                                   <span class="fa fa-user-slash">{t("blokieren")}</span>
                                }
                                
                            </Button>
                        </OverlayTrigger>
                        
                    </Col>
                    <Col lg={2}  xs={2}>
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={
                        <Tooltip id={`tooltip-top`}>
                            {t("speichern")}
                        </Tooltip>
                        }>
                        <Button variant="outline-primary" onClick={() =>  this.props.onInvitedEdit(this.state.invited)} className="float-left  "><span class="fa fa-save">&nbsp; {t("speichern")}</span></Button>
                        </OverlayTrigger>
                    </Col>
                    <Col lg={1}  xs={1}>
                        &nbsp;
                    </Col>
                </Row>
           </div>
        )
    }
}

export default translate("translations")(InvitedEdit);